import { NgModule } from '@angular/core';
import { AccredibleTrackingApiService } from './tracking.service';

@NgModule({
  providers: [AccredibleTrackingApiService],
})
export class AccredibleTrackingApiServiceModule {}
